import FeaturePage from "@/features/_shared/FeaturePage";

import NoChallengePlanned from "../components/noChallengePlanned/noChallengePlanned";
import LeaderboardPage from "../components/leaderboard/LeaderboardPage";
import GapScreen from "../components/challengeUpcoming/GapScreen";
import EndscreenPage from "../components/endscreen/EndscreenPage";

// TEMP TEST: swap the Leaderboard slot to GapScreen to preview the gap rotation
// (results <-> next-challenge countdown) over the live state. To restore normal
// behaviour, set Leaderboard back to {LeaderboardPage}.
const TESTING_GAP_ROTATION = false;

const SamsungRacing = () => (
  <FeaturePage
    Countdown={GapScreen}
    Leaderboard={TESTING_GAP_ROTATION ? GapScreen : LeaderboardPage}
    Endscreen={EndscreenPage}
    NoPlan={NoChallengePlanned}
    noContainer
  />
);

export default SamsungRacing;
